import React, { useEffect, useRef } from 'react'
import FocusTrap from 'focus-trap-react'
import { CloseButton } from 'components/Button/CloseButton'
import { useModalScroll } from 'hooks/useModalScroll'
import useKeyPress from 'hooks/useKeyPress'

export interface DrawerProps {
  className?: string;
  children?: React.ReactNode;
  title: string;
  onClose: () => void;
}

export const Drawer: React.FC<DrawerProps> = ({ className, children, title, onClose }) => {
  useKeyPress('Escape', onClose)
  useModalScroll()

  // Focus heading when opened
  const headingRef = useRef<HTMLHeadingElement>(null)
  useEffect(() => {
    headingRef.current?.focus()
  }, [])

  return (
    <>
      <div className='ch-c-drawer__overlay' data-testid='background' />
      <div className={`ch-c-drawer__content ${className ?? ''}`} role='dialog' aria-modal='true'>
        <FocusTrap>
          {/* Include padding for Safari screens so the bottom of the drawer doesn't get covered by menu options */}
          <div className='ds-u-padding-bottom--4'>
            <div className='ch-c-drawer__header'>
              <h1 className='ds-text-heading--2xl my-u-my--12' ref={headingRef} tabIndex={-1}>{title}</h1>
              <CloseButton onClose={onClose} data-testid='drawer-close-btn' />
            </div>
            {children}
          </div>
        </FocusTrap>
      </div>
    </>
  )
}
